import { defineComponent as a, computed as o, openBlock as c, createElementBlock as i, createElementVNode as e, toDisplayString as f, createCommentVNode as d, normalizeStyle as _ } from "vue";
const h = ["viewBox"], m = /* @__PURE__ */ e("mask", { id: "f4553781-0199-4bd6-af2c-31ff5538fc94" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#f4553781-0199-4bd6-af2c-31ff5538fc94)" }, k = { key: 0 }, p = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "m0 384 255.8-29.7L512 384v128H0z"
}, null, -1), v = /* @__PURE__ */ e("path", {
  fill: "#0052b4",
  d: "m0 256 259.5-31L512 256v128H0z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#ffda44",
  d: "M0 0h512v256H0z"
}, null, -1), x = { fill: "none" }, w = ["r"], B = /* @__PURE__ */ a({
  __name: "co",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const t = r, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), n = o(() => 256 + t.strokeWidth / 2);
    return (y, W) => (c(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      m,
      e("g", u, [
        t.flagName ? (c(), i("title", k, f(t.flagName), 1)) : d("", !0),
        p,
        v,
        g
      ]),
      e("g", x, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: n.value,
          fill: "none",
          style: _({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, w)
      ])
    ], 8, h));
  }
});
export {
  B as default
};
//# sourceMappingURL=co-4533f65b.js.map
